import './App.css';
import './styles/override.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MiniDrawer from './components/MiniDrawer';
import Login from './pages/Login';
import Logout from './pages/Logout';
import ProtectedRoute from './components/ProtectedRoute';
import { getCurrentEnvironment } from './config/local.config';
import { buildAppTheme } from './theme/appTheme';

// Tema chiaro di base; MiniDrawer applica quello scuro alle pagine V2 se l'utente lo sceglie
const theme = buildAppTheme('light');

function App() {
  // Imposta il titolo della scheda del browser in base all'ambiente
  useEffect(() => {
    const environment = getCurrentEnvironment();
    const baseTitle = 'RUNTime';
    
    // Aggiungi prefisso per ambienti non-production
    let title = baseTitle;
    
    if (environment === 'development') {
      title = `[DEV] ${baseTitle}`;
      document.title = title;
    } else if (environment === 'labs') {
      title = `[LABS] ${baseTitle}`;
      document.title = title;
    } else {
      // Production mantiene il titolo originale
      document.title = baseTitle;
    }
    
    console.log('🏷️ Browser tab title set to:', title);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Route pubbliche (non protette) */}
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />

          {/* Route protette - tutte le altre pagine richiedono autenticazione */}
          <Route path="/*" element={<MiniDrawer />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
